import React from 'react';
import { SvgIcon } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
type Props = {
  className?: string;
};
const CloseIcon = (props: Props) => {
  const theme: any = useTheme();
  return (
    <SvgIcon width='40' height='40' viewBox='0 0 40 40' fill='none' {...props}>
      <path d='M28 12L12 28M12 12L28 28' stroke={theme.palette.common.black} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </SvgIcon>
  );
};
export default CloseIcon;
